// define a mixin object
import anime from 'animejs';
import { isTouchDevice } from '@/scripts/utils';


// eslint-disable-next-line import/prefer-default-export
export default {
  data() {
    return {
      isOver: false,
      isOpening: true,
    };
  },
  computed: {
    anotherIsAnimating() {
      return this.$store.state.arrowInTransition;
    },
  },
  methods: {
    overAnimation(targets, reverse = false) {
      const delta = targets.length * 2;

      anime({
        targets,
        translateX: reverse ? 0 : anime.stagger([-delta, delta]),
        duration: 1200,
        easing: 'easeOutExpo',
        // duration: 600,
        // easing: 'easeOutSine',
      });
    },
    mEnter(ev) {
      if (!isTouchDevice()) {
        if (!this.isOpening) {
          this.isOver = true;
          const targets = ev.target.getElementsByClassName('stagger-element');
          if (!this.anotherIsAnimating) {
            this.overAnimation(targets);
          }
        }
      }
    },
    mLeave(ev) {
      if (!isTouchDevice()) {
        if (!this.isOpening) {
          this.isOver = false;
          const targets = ev.target.getElementsByClassName('stagger-element');
          if (!this.anotherIsAnimating) {
            this.overAnimation(targets, true);
          }
        }
      }
    },
  },
};
